module.exports = __webpack_public_path__ + "static/media/crossing-lines.586db8ee.jpg";